import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Toggle} from '../../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {ChannelEmailModel} from '../../../../models/api/channelModel';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';
import {SettingsCommonChannelFieldProps} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface SettingsTrackingFieldProps extends SettingsCommonChannelFieldProps<ChannelEmailModel> {}

/*
 * Component.
 */

export const SettingsTrackingField: FC<SettingsTrackingFieldProps> = (props) => (
  <SettingsFieldLine
    title={<Trans id="settingschannel-emailtracking-title">Track sent emails</Trans>}
    subtitle={
      <Trans id="settingschannel-emailtracking-subtitle">
        Front will attempt to track when recipients open emails you send.
      </Trans>
    }
    content={
      <Toggle
        isChecked={props.edited.preferences.shouldEnableEmailTracking}
        onChange={(newValue) =>
          props.onPreferencesChange({
            shouldEnableEmailTracking: newValue,
          })
        }
      />
    }
  />
);
